import { useDataChange } from 'Simple/Data'

export function useOnChange(props) {
  let change = useDataChange({
    context: 'form',
    path: 'priority',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    change(value || 'medium')
  }
}
